exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-card-body[data-v-347f00e1]{padding:20px}.modal-card-body article[data-v-347f00e1]{padding:10px;margin-bottom:1rem;-webkit-transition:-webkit-transform .3s ease;transition:-webkit-transform .3s ease;transition:transform .3s ease;transition:transform .3s ease, -webkit-transform .3s ease}.modal-card-body article[data-v-347f00e1]:hover{-webkit-transform:scale(1.015);transform:scale(1.015);background-color:rgba(222,222,222,.5)}.modal-card[data-v-347f00e1]{width:800px}.alert-message[data-v-347f00e1]{background-color:#fff8e1;border:1px solid #ffe082;border-radius:8px;padding:16px 20px;color:#6b5500;font-size:14px;line-height:1.5}", ""]);

// exports
